import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/authSlice';
import { pickingApi } from './api/pickingApi';
import { incomingAiInvoicesApi } from './api/incomingAiInvoicesApi';
import { stocktakeApi } from './api/stocktakeApi';
import { docConfirmationApi } from './api/docConfirmationApi';
import { productsApi } from './api/productsApi';

const store = configureStore({
  reducer: {
    auth: authReducer,
    [pickingApi.reducerPath]: pickingApi.reducer,
    [incomingAiInvoicesApi.reducerPath]: incomingAiInvoicesApi.reducer,
    [stocktakeApi.reducerPath]: stocktakeApi.reducer,
    [docConfirmationApi.reducerPath]: docConfirmationApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      pickingApi.middleware,
      incomingAiInvoicesApi.middleware,
      stocktakeApi.middleware,
      docConfirmationApi.middleware,
      productsApi.middleware
    ),
});

export default store;